module.exports = __webpack_public_path__ + "static/media/CPE_Logo_959x1024_1719597825809.39a0145b.png";